/**
 * SceneEventsSubsystem — Flushes queued SceneEvents at the start of each frame.
 *
 * Priority is set below Core (earliest possible) so that all other subsystems
 * receive object/component add/remove notifications before they run their own
 * update logic for the frame.
 *
 * Shared between editor and player — lives in @engine/core.
 */

import { Subsystem, SubsystemPriority, type SubsystemConfig } from './Application';
import { levelManager } from './LevelManager';

export class SceneEventsSubsystem extends Subsystem {
  readonly config: SubsystemConfig = {
    name: 'scene-events',
    priority: SubsystemPriority.Core - 10, // earliest possible
  };

  onUpdate(_deltaTime: number): void {
    // Flush every loaded level's event queue (including DontDestroyOnLoad)
    for (const level of levelManager.levels()) {
      if (level.events.dirty) {
        level.events.flush();
      }
    }
  }
}
